module.exports = __webpack_public_path__ + "img/home_swiper_01_mobile.65458f50.jpg";